import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  const f = t.faq;
  return (
    <section id="faq" data-testid="faq-section" className="section-y bg-cream-50 border-t border-ink-900/8">
      <div className="container-x grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <span className="hairline" />
            <span className="text-overline">{f.overline}</span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-ink-900 tracking-tight leading-tight">
            {f.h2a}{" "}
            <span className="text-brand-500">{f.h2accent}</span> {f.h2b}
          </h2>
          <p className="mt-6 text-base text-ink-500 leading-relaxed">{f.sub}</p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {f.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-accordion-item-${i + 1}`}
                className="border-ink-900/10"
              >
                <AccordionTrigger className="text-left font-display font-bold text-lg sm:text-xl text-ink-900 hover:text-brand-600 hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink-500 text-base leading-relaxed pb-6 pr-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
